import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // 5秒後に自動的にフラッシュメッセージを消す
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"
    
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
